import BackendService from './BackendService';

export class IncentiveService {
  static getIncentives(
    deskingId: string,
    deskingOfferId: string,
    selectedCustomerTypeId?: number,
  ) {
    const params: { customerTypeId?: number } = {};

    if (selectedCustomerTypeId !== undefined) {
      params.customerTypeId = selectedCustomerTypeId;
    }

    return BackendService.get(
      `/v2/workflow/desking/${deskingId}/offer/${deskingOfferId}/incentives`,
      {
        params,
      },
    );
  }

  static getCompatibleIncentives<T>(
    deskingId: string,
    selectedIncentiveIds: number[],
  ): Promise<T> {
    return BackendService.get(
      `/v2/workflow/desking/${deskingId}/incentives/compatibility`,
      {
        params: {
          ids: selectedIncentiveIds,
        },
      },
    );
  }
}
